import React, { useEffect, useState } from "react";
import { fetchAllTests } from "../api";
import TestCard from "../components/TestCard";
import CreateTestModal from "../components/CreateTestModal";
import EditTestModal from "../components/EditTestModal";

export default function Home({ user, assignmentsJson }) {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  // edit modal state
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [editingTest, setEditingTest] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchAllTests().then((list) => {
      if (mounted) {
        let newList = [];
        list.forEach((test) => {
          const isOwner = user && test && user.uid === test.ownerUid;
          const isShared =
            user &&
            user.emailVerified &&
            test &&
            ((test.sharedWith || []).includes(user.uid) ||
              (test.sharedWith || []).includes(user.email));
          const isPublic = user && test && test.isPublic;
          const allowed = !!(isOwner || isShared || isPublic);
          if (allowed) newList.push(test);
        });
        setTests(newList);
      }
      setLoading(false);
    });
    return () => (mounted = false);
  }, [user, showCreate]);

  // called when clicking Edit from a TestCard
  function handleEditRequest(test) {
    setEditingTest(test);
    setDetailsOpen(true);
  }

  // called after successful save in modal; updates local list
  function handleSaved(updatedTest) {
    setTests((prev) =>
      prev.map((t) => (t.id === updatedTest.id ? updatedTest : t))
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Available Tests</h1>
        <div className="flex items-center gap-3">
          {user && user.emailVerified && (
            <button
              className="px-4 py-2 bg-green-600 text-white rounded"
              onClick={() => setShowCreate(true)}
            >
              Create Test
            </button>
          )}
        </div>
      </div>

      {showCreate && (
        <CreateTestModal
          onClose={() => setShowCreate(false)}
          owner={user}
          assignmentsJson={assignmentsJson}
        />
      )}

      {detailsOpen && editingTest && (
        <EditTestModal
          test={editingTest}
          onClose={() => setDetailsOpen(false)}
          onSaved={handleSaved}
        />
      )}

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {tests.length > 0 ? (
            tests.map((t) => (
              <div key={t.id} className="relative">
                <TestCard
                  test={t}
                  user={user}
                  setTests={setTests}
                  onEdit={handleEditRequest}
                />
              </div>
            ))
          ) : (
            <div className="text-xl text-rose-600">No tests available!</div>
          )}
        </div>
      )}
    </div>
  );
}
